module.exports = __webpack_public_path__ + "media/categories/4028-88c9bc6c.svg";